import { Module } from 'wrapper6'

const $ = jQuery

export default class ScrollDown extends Module {
  ready (app) {
    this.initScroll()
    this.urlHashScroll()
  }

  initScroll () {
    // scroll to top
    const LOCAL_MENU_TITLE = document.querySelector('.local-menu__title')
    LOCAL_MENU_TITLE && LOCAL_MENU_TITLE.addEventListener('click', () => $('html, body').animate({ scrollTop: 0 }, 700))

    const _this = this
    $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault()
      _this.scroll($.attr(this, 'href'))
    })
  }

  scroll (element) {
    const _this = this
    if (_this.elementExists(element) !== null) {
      $('html, body').animate({
        scrollTop: $(element).offset().top - _this.getHeaderHeight()
      }, 700)
    }
  }

  elementExists (href) {
    return document.getElementById(href.replace('#', ''))
  }

  getHeaderHeight () {
    let height = 0
    const HEADER = document.getElementById('main_header')
    HEADER && (height += HEADER.getBoundingClientRect().height)
    const ADMIN_BAR = document.getElementById('wpadminbar')
    ADMIN_BAR && (height += ADMIN_BAR.getBoundingClientRect().height)
    return height
  }

  urlHashScroll () {
    const hash = window.location.hash
    if (hash !== '') {
      this.scroll(hash)
      window.history.pushState('hash', '', window.location.href.split('#')[0])
    }
  }
}
